<template>
  <div class="room-doc-list-component" data-grm-comp="List">
    <ul class="room-doc-list">
      <li v-for="roomDocFile in roomDoc.roomDocFiles"
          :key="roomDocFile.docId"
          class="room-doc-item"
          :class="[
            roomDocFile.docType,
            { selected: roomDocFile.docId === roomDoc.docId }
          ]"
          :data-docId="roomDocFile.docId"
      >
        <div class="room-doc-select-button" @click="onClickFile(roomDocFile)"></div>
        <div class="room-doc">
          <lazy-component class="room-doc-thumb"
              v-if="isDocFileConverted(roomDocFile) || roomDocFile.docFile.docConvPageCnt > 0"
              @show="loadRoomDocFileThumbnail(roomDocFile, $event)"
          >
            <img>
          </lazy-component>
        </div>
        <div class="room-doc-title-wrapper">
          <p class="room-doc-title">{{ roomDocFile.docName }}
            <template v-if="hasDocFilePage(roomDocFile)">({{ roomDocFile.currDocPageSeq }}/{{ roomDocFile.docFile.docPageCnt > 0 ? roomDocFile.docFile.docPageCnt+'p' : '...' }})</template>
          </p>
        </div>
        <div class="room-doc-progress" v-if="isDocFileConverting(roomDocFile)">
          <div class="room-doc-progress-bar"
               v-if="roomDocFile.docFile.docPageCnt > 0"
               :style="{width: `${roomDocFile.docFile.docConvPageCnt / roomDocFile.docFile.docPageCnt * 100}%`}"
          />
          <div class="room-doc-progress-text">
            <span>{{ $t("doc.list.transform.ongoing") }}</span>
            <span>
              - {{ roomDocFile.docFile.docConvPageCnt }}/{{ roomDocFile.docFile.docPageCnt > 0 ? roomDocFile.docFile.docPageCnt : '...' }}
            </span>
          </div>
        </div>
        <div class="room-doc-progress" v-else-if="roomDocFile.docFile && roomDocFile.docFile.docState === 0">
          <div class="room-doc-progress-text">{{ $t("doc.list.transform.ready") }}</div>
        </div>
        <div class="room-doc-button-wrapper">
          <button class="room-doc-button" @click="onToggleModal(roomDocFile)"></button>
          <GrmMenu
              :open.sync="isShowMoreModal[roomDocFile.docId]"
              :list="modalList(roomDocFile)"
          />
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import Vue from "vue";
import {mapActions, mapGetters, mapState} from "vuex";

import GrmMenu from "@/components/Common/menu/GrmMenu"
import DocSave from '@/components/Room/Doc/Save'

export default {
  name: 'RoomDocList',
  components: {
    GrmMenu,
  },
  data() {
    return {
      isShowMoreModal: {},
    }
  },
  computed: {
    ...mapGetters('user', ['hasEmceeRole']),
    ...mapState('doc', [
      'uploadRoomDocFiles',
      'chosenDocFile',
    ]),
    ...mapGetters('doc', [
      'roomDoc',
      'allowedFileExts',
      'sharingRoomDoc',
      'sharingRoomGroupId',
      'isWhiteBoardFile',
      'isDocFileConverting',
      'isDocFileConverted',
      'isDocFileConvertError',
      'hasDocFilePage',
    ]),
    modalList() {
      return roomDocFile => {
        const modal = []

        if(roomDocFile.useDownload !== false){
          modal.push({
              title: this.$t('common.save'),
                  click: () => {
              this.$modal(DocSave, {
                data: {
                  roomDocFile
                }
              })
            }
          })
        }

        if (!roomDocFile.isWhiteboard && this.hasEmceeRole()) {
          modal.push({
            title: this.$t('common.delete'),
            click: () => {
              this.reqRemoveRoomDocFile(roomDocFile);
            }
          })
        }

        return modal
      }
    },
  },
  methods: {
    ...mapActions('doc', [
      'changeRoomDocPage',
      'removeRoomDocFile',
      'getRoomDocUrl',
    ]),
    async loadRoomDocFileThumbnail(roomDocFile, $comp) {
      let url = await this.getRoomDocUrl({
        roomGroupId: roomDocFile.roomGroupId,
        docId: roomDocFile.docId,
        thumbnail: true
      });

      if($comp?.$el?.querySelector('img')){
        let img = $comp.$el.querySelector('img');
        img.src = url;
      }
      return url;
    },
    async onClickFile(roomDocFile) {
      await this.changeRoomDocPage({
        roomGroupId: roomDocFile.roomGroupId,
        docId: roomDocFile.docId,
        docPageId: roomDocFile.currDocPageId
      });
      if(roomDocFile.pages){
        this.$emit('setShowDocPage', true)
      }
    },
    onToggleModal(docFile) {
      this.isShowMoreModal[docFile.docId] === undefined
          ? Vue.set(this.isShowMoreModal, docFile.docId, true)
          : this.isShowMoreModal[docFile.docId] = !this.isShowMoreModal[docFile.docId]
    },
    reqRemoveRoomDocFile(roomDocFile) {
      this.$alert({
        text: this.$t('doc.list.deleteDoc'),
        ok: () => {
          this.removeRoomDocFile(roomDocFile);
        }
      })
    },
  },
  watch: {
    async chosenDocFile(val) {
      if (val.docId) {
        this.currentDocId = val.docId
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.room-doc-list-component {}
.room-doc-list {
  display: flex;
  flex-direction: column;
  gap: 16px 0;
}
.room-doc-item {
  width: 100%;
  position: relative;
  cursor: pointer;
  &.selected {
    .room-doc-page-number {
      color: #09f;
    }
    .room-doc {
      border: 4px solid #09f !important;
    }
    .room-doc-title {
      color: #09f;
    }
  }
  &:hover {
    .room-doc {
      border: 1px solid #46cff3;
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2)
    }
    .room-doc-title {
      color: #09f;
    }
  }
}
.room-doc {
  height: 56px;
  border: 1px solid #ccc;
  background-color: #fff;
  position: relative;
  pointer-events: none;
  transition: 0.1s ease-out;
  overflow: hidden;

  .room-doc-thumb {
    width: 100%;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}
.room-doc-select-button {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.room-doc-page {
  margin-bottom: 4px;
}
.room-doc-page-number {
  font-size: 10px;
  color: #666;
  transition: 0.1s ease-out;
}
.room-doc-title-wrapper {
  margin-top: 4px;
  text-align: center;
}
.room-doc-title {
  font-size: 10px;
  color: #999;
  line-height: 1.4;
  transition: 0.1s ease-out;
  pointer-events: none;
  word-break: break-all;
}
.room-doc-progress {
  width: 100%;
  margin-top: 6px;
  border-radius: 4px;
  background-color: #fff;
  position: relative;
  overflow: hidden;
}
.room-doc-progress-bar {
  background-color: #59f;
  position: absolute;
  inset: 0 auto 0 0;
  transition: 0.1s ease-out;
}
.room-doc-progress-text {
  font-size: 10px;
  text-align: center;
  line-height: 20px;
  position: relative;
}
.room-doc-button-wrapper {
  position: absolute;
  top: 0;
  right: 0;

  .grm-menu-component {
    position: absolute;
    top: 100%;
    right: 0;
  }
}
.room-doc-button {
  width: 30px;
  height: 24px;
  background: url('~@/assets/images/more_gray.svg') no-repeat center / 16px auto;
  transition: 0.1s ease-out;

  &:hover {
    background: $mainColor url('~@/assets/images/more_white.svg') no-repeat center / 16px auto;
  }
}
</style>